const translations = {
  fr: {
    // Navigation
    nav_dashboard: 'Tableau de Bord',
    nav_worklist: 'À traiter',
    nav_briefing: 'Mon matin',
    nav_pipeline: 'Pipeline',
    nav_institutions: 'Institutions',
    nav_marketplace: 'Place de marché',
    nav_impact: 'Impact & ODD',
    nav_knowledge: 'Hub de connaissances',
    nav_formation: 'Centre de formation',
    nav_search: 'Recherche',
    nav_analytics: 'Analyses',
    nav_compare: 'Comparer',
    nav_submit: 'Soumettre',
    nav_admin: 'Admin',
    nav_profile: 'Mon Profil',
    nav_messages: 'Messages',

    // Header
    logout: 'Déconnexion',
    
    // Landing
    landing_badge: '27 Banques de Développement | ODD | Accord de Paris',
    landing_hero_1: 'International',
    landing_hero_2: 'Development Finance',
    landing_hero_3: 'Club',
    landing_desc: "La plateforme institutionnelle de co-financement pour les 27 banques membres de l'IDFC. Découvrez, analysez et co-financez des projets de développement durable alignés sur les ODD et l'Accord de Paris.",
    landing_cta: 'Accéder à la Plateforme',
    landing_learn_more: 'En Savoir Plus',
    landing_cta_bottom: 'Prêt à Co-Financer ?',
    landing_cta_bottom_desc: "Rejoignez la plateforme qui connecte les 27 institutions membres de l'IDFC avec des projets de développement durable à travers le monde.",
    landing_start: 'Commencer',
    landing_access: 'Accéder',

    // Stats
    stat_annual: 'Engagements Annuels',
    stat_members: 'Membres IDFC',
    stat_sdg: 'ODD Couverts',
    stat_continents: 'Continents',

    // Sections
    section_sdg_title: "Aligné sur les ODD & l'Accord de Paris",
    section_sdg_desc: "L'IDFC mobilise collectivement plus de 900 milliards de dollars par an pour contribuer aux Objectifs de Développement Durable des Nations Unies et aux engagements climatiques de l'Accord de Paris.",
    section_sdg_goals: 'Objectifs de Développement Durable',
    section_paris: 'Accord de Paris',
    section_how_title: 'Comment ça Fonctionne',
    section_how_desc: 'De la découverte de projet à la clôture du deal en quatre étapes.',
    section_sectors_title: "Secteurs d'Intervention",
    section_sectors_desc: "Projets d'infrastructure et de développement durable à travers les secteurs à plus fort impact.",
    section_platform_title: 'Conçue pour la Prise de Décision Institutionnelle',
    section_platform_desc: "Chaque fonctionnalité est conçue pour accélérer les workflows de co-financement et soutenir les comités d'investissement.",
    section_members_title: "Les 27 Membres de l'IDFC",
    section_members_desc: "Un réseau unique de banques nationales et régionales de développement, présent sur 4 continents, mobilisant collectivement plus de 900 milliards $ par an.",
    section_faq_title: 'Questions Fréquentes',
    section_footer: "International Development Finance Club | 27 Membres | ODD & Accord de Paris",

    // Search
    search_title: 'Recherche Avancée',
    search_placeholder: 'Rechercher par titre, pays, secteur, description...',
    search_filters: 'Filtres',
    search_reset: 'Réinitialiser',
    search_country: 'Pays',
    search_sector: 'Secteur',
    search_stage: 'Étape',
    search_risk: 'Niveau de Risque',
    search_amount: 'Montant',
    search_sort: 'Trier par',
    search_all_countries: 'Tous les pays',
    search_all_sectors: 'Tous les secteurs',
    search_all_stages: 'Toutes les étapes',
    search_all_risks: 'Tous les niveaux',
    search_relevance: 'Pertinence',
    search_recent: 'Plus récents',
    search_funding_desc: 'Montant (desc.)',
    search_funding_asc: 'Montant (asc.)',
    search_readiness: 'Maturité',
    search_results: '{count} résultat{s} trouvé{s}',
    search_results_one: 'résultat trouvé',
    search_results_plural: 'résultats trouvés',
    search_no_results: 'Aucun projet trouvé. Essayez d\'ajuster vos critères de recherche.',
    search_loading: 'Recherche en cours...',

    // Analytics
    analytics_title: 'Analytics Avancés',
    analytics_pipeline: 'Pipeline Total',
    analytics_projects: 'Projets Actifs',
    analytics_institutions: 'Institutions',
    analytics_conversion: 'Taux de Conversion',
    analytics_by_sector: 'Pipeline par Secteur',
    analytics_by_country: 'Pipeline par Pays',
    analytics_by_stage: 'Répartition par Étape',
    analytics_by_risk: 'Distribution du Risque',
    analytics_funding_gap: 'Analyse du Gap de Financement',
    analytics_funding: 'Financement',
    analytics_gap: 'Gap',
    analytics_required: 'Requis',

    // Profile
    profile_title: 'Mon Profil',
    profile_change_password: 'Changer le Mot de Passe',
    profile_current_pw: 'Mot de passe actuel',
    profile_new_pw: 'Nouveau mot de passe',
    profile_confirm_pw: 'Confirmer le nouveau mot de passe',
    profile_change_btn: 'Modifier le mot de passe',
    profile_changing: 'Modification...',
    profile_activity: "Historique d'Activité",
    profile_no_activity: 'Aucune activité récente enregistrée.',
    profile_pw_mismatch: 'Les mots de passe ne correspondent pas',
    profile_pw_short: 'Le mot de passe doit contenir au moins 8 caractères',
    profile_pw_success: 'Mot de passe modifié avec succès',

    // Alerts
    alerts_title: 'Alertes Intelligentes',
    alerts_desc: "Recevez une notification automatique lorsqu'un nouveau projet correspondant à vos critères est soumis sur la plateforme.",
    alerts_sectors: "Secteurs d'intérêt",
    alerts_countries: 'Pays ciblés',
    alerts_stages: 'Étapes préférées',
    alerts_risks: 'Niveaux de risque',
    alerts_min: 'Montant min ($)',
    alerts_max: 'Montant max ($)',
    alerts_save: 'Sauvegarder les préférences',
    alerts_saving: 'Sauvegarde...',
    alerts_matches: 'Projets Correspondants',
    alerts_matches_count: '{count} match{s}',
    alerts_config_hint: 'Configurez vos préférences ci-dessus pour voir les projets correspondants.',
    alerts_no_match: 'Aucun projet ne correspond actuellement à vos critères.',
    alerts_saved: "Préférences d'alertes sauvegardées",
    alerts_active: 'Actif',
    alerts_inactive: 'Inactif',

    // Messages
    messages_title: 'Messagerie Deal Room',
    messages_placeholder: 'Tapez votre message...',
    messages_send: 'Envoyer',
    messages_empty: 'Aucun message dans cette salle de deals. Commencez la conversation !',
    messages_visibility_all: 'Visible par tous',
    messages_visibility_inst: 'Institutionnel uniquement',

    // Roles
    role_admin: 'Administrateur',
    role_institution: 'Institution',
    role_donor: 'Donateur',
    role_project_owner: 'Promoteur de Projet',

    // Sectors
    sector_energy: 'Énergie',
    sector_infrastructure: 'Infrastructure',
    sector_agriculture: 'Agriculture',
    sector_climate: 'Climat',

    // Stages
    stage_early: 'Précoce',
    stage_structuring: 'Structuration',
    stage_ready: 'Prêt à investir',

    // Risks
    risk_low: 'Faible',
    risk_medium: 'Moyen',
    risk_high: 'Élevé',

    // Tour
    tour_welcome: 'Bienvenue sur IDFC',
    tour_welcome_desc: "Découvrez les fonctionnalités clés de la plateforme de co-financement pour les 27 banques membres de l'IDFC. Ce tour guidé ne prendra que quelques instants.",
    tour_skip: 'Passer',
    tour_start: 'Commencer le Tour',
    tour_back: 'Retour',
    tour_next: 'Suivant',
    tour_last: 'Terminer',
    tour_close: 'Fermer',
    tour_skip_all: 'Passer le tour',

    // Common
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    projects: 'Projets',

    // Dashboard labels
    dash_total_projects: 'Total Projets',
    dash_pipeline_value: 'Valeur du Pipeline',
    dash_funding_gap: 'Gap de Financement',
    dash_active_deals: 'Deals Actifs',
    dash_filters: 'Filtres',
    dash_sort: 'Tri',
    dash_score_filter: 'Filtre Score',
    dash_all_sectors: 'Tous les Secteurs',
    dash_all_stages: 'Toutes les Étapes',
    dash_all_countries: 'Tous les Pays',
    dash_all_institutions: 'Toutes les Institutions',
    dash_default_order: 'Ordre par défaut',
    dash_funding_desc: 'Financement (desc)',
    dash_gap_asc: 'Gap (asc)',
    dash_return_desc: 'Rendement (desc)',
    dash_sector_distribution: 'Distribution Sectorielle',
    dash_by_country: 'Par Pays',
    dash_recent_activity: 'Activité Récente',
    dash_investment_ready: 'Projets Prêts à Investir',
    dash_seed_data: 'Données Démo',
    dash_required: 'Requis',
    dash_gap: 'Gap',
    dash_return: 'Rendement',
    dash_add_favorite: 'Ajouter aux favoris',
    dash_remove_favorite: 'Retirer des favoris',
    dash_favorites: 'Mes Favoris',
  },

  en: {
    // Navigation
    nav_dashboard: 'Dashboard',
    nav_worklist: 'To handle',
    nav_briefing: 'My briefing',
    nav_pipeline: 'Pipeline',
    nav_institutions: 'Institutions',
    nav_marketplace: 'Marketplace',
    nav_impact: 'Impact & SDG',
    nav_knowledge: 'Knowledge Hub',
    nav_formation: 'Training Center',
    nav_search: 'Search',
    nav_analytics: 'Analytics',
    nav_compare: 'Compare',
    nav_submit: 'Submit',
    nav_admin: 'Admin',
    nav_profile: 'My Profile',
    nav_messages: 'Messages',

    // Header
    logout: 'Logout',

    // Landing
    landing_badge: '27 Development Banks | SDGs | Paris Agreement',
    landing_hero_1: 'International',
    landing_hero_2: 'Development Finance',
    landing_hero_3: 'Club',
    landing_desc: 'The institutional co-financing platform for the 27 IDFC member banks. Discover, analyze and co-finance sustainable development projects aligned with the SDGs and the Paris Agreement.',
    landing_cta: 'Access Platform',
    landing_learn_more: 'Learn More',
    landing_cta_bottom: 'Ready to Co-Finance?',
    landing_cta_bottom_desc: 'Join the platform connecting the 27 IDFC member institutions with sustainable development projects worldwide.',
    landing_start: 'Get Started',
    landing_access: 'Access',

    // Stats
    stat_annual: 'Annual Commitments',
    stat_members: 'IDFC Members',
    stat_sdg: 'SDGs Covered',
    stat_continents: 'Continents',

    // Sections
    section_sdg_title: 'Aligned with SDGs & Paris Agreement',
    section_sdg_desc: 'IDFC collectively mobilizes over $900 billion annually to contribute to the UN Sustainable Development Goals and the Paris Agreement climate commitments.',
    section_sdg_goals: 'Sustainable Development Goals',
    section_paris: 'Paris Agreement',
    section_how_title: 'How It Works',
    section_how_desc: 'From project discovery to deal closing in four streamlined steps.',
    section_sectors_title: 'Sectors We Cover',
    section_sectors_desc: 'Infrastructure and sustainable development projects across the highest-impact sectors.',
    section_platform_title: 'Built for Institutional Decision-Making',
    section_platform_desc: 'Every feature is designed to accelerate co-financing workflows and support investment committee processes.',
    section_members_title: 'The 27 IDFC Members',
    section_members_desc: 'A unique network of national and regional development banks, present on 4 continents, collectively mobilizing over $900 billion per year.',
    section_faq_title: 'Frequently Asked Questions',
    section_footer: 'International Development Finance Club | 27 Members | SDGs & Paris Agreement',

    // Search
    search_title: 'Advanced Search',
    search_placeholder: 'Search by title, country, sector, description...',
    search_filters: 'Filters',
    search_reset: 'Reset',
    search_country: 'Country',
    search_sector: 'Sector',
    search_stage: 'Stage',
    search_risk: 'Risk Level',
    search_amount: 'Amount',
    search_sort: 'Sort by',
    search_all_countries: 'All countries',
    search_all_sectors: 'All sectors',
    search_all_stages: 'All stages',
    search_all_risks: 'All levels',
    search_relevance: 'Relevance',
    search_recent: 'Most recent',
    search_funding_desc: 'Amount (desc.)',
    search_funding_asc: 'Amount (asc.)',
    search_readiness: 'Readiness',
    search_results: '{count} result{s} found',
    search_results_one: 'result found',
    search_results_plural: 'results found',
    search_no_results: 'No projects found. Try adjusting your search criteria.',
    search_loading: 'Searching...',

    // Analytics
    analytics_title: 'Advanced Analytics',
    analytics_pipeline: 'Total Pipeline',
    analytics_projects: 'Active Projects',
    analytics_institutions: 'Institutions',
    analytics_conversion: 'Conversion Rate',
    analytics_by_sector: 'Pipeline by Sector',
    analytics_by_country: 'Pipeline by Country',
    analytics_by_stage: 'Breakdown by Stage',
    analytics_by_risk: 'Risk Distribution',
    analytics_funding_gap: 'Funding Gap Analysis',
    analytics_funding: 'Funding',
    analytics_gap: 'Gap',
    analytics_required: 'Required',

    // Profile
    profile_title: 'My Profile',
    profile_change_password: 'Change Password',
    profile_current_pw: 'Current password',
    profile_new_pw: 'New password',
    profile_confirm_pw: 'Confirm new password',
    profile_change_btn: 'Change password',
    profile_changing: 'Changing...',
    profile_activity: 'Activity History',
    profile_no_activity: 'No recent activity recorded.',
    profile_pw_mismatch: 'Passwords do not match',
    profile_pw_short: 'Password must be at least 8 characters',
    profile_pw_success: 'Password changed successfully',

    // Alerts
    alerts_title: 'Smart Alerts',
    alerts_desc: 'Receive automatic notifications when a new project matching your criteria is submitted on the platform.',
    alerts_sectors: 'Sectors of interest',
    alerts_countries: 'Target countries',
    alerts_stages: 'Preferred stages',
    alerts_risks: 'Risk levels',
    alerts_min: 'Min amount ($)',
    alerts_max: 'Max amount ($)',
    alerts_save: 'Save preferences',
    alerts_saving: 'Saving...',
    alerts_matches: 'Matching Projects',
    alerts_matches_count: '{count} match{s}',
    alerts_config_hint: 'Configure your preferences above to see matching projects.',
    alerts_no_match: 'No projects currently match your criteria.',
    alerts_saved: 'Alert preferences saved',
    alerts_active: 'Active',
    alerts_inactive: 'Inactive',

    // Messages
    messages_title: 'Deal Room Messaging',
    messages_placeholder: 'Type your message...',
    messages_send: 'Send',
    messages_empty: 'No messages in this deal room yet. Start the conversation!',
    messages_visibility_all: 'Visible to all',
    messages_visibility_inst: 'Institution only',

    // Roles
    role_admin: 'Administrator',
    role_institution: 'Institution',
    role_donor: 'Donor',
    role_project_owner: 'Project Owner',

    // Sectors
    sector_energy: 'Energy',
    sector_infrastructure: 'Infrastructure',
    sector_agriculture: 'Agriculture',
    sector_climate: 'Climate',

    // Stages
    stage_early: 'Early',
    stage_structuring: 'Structuring',
    stage_ready: 'Investment-ready',

    // Risks
    risk_low: 'Low',
    risk_medium: 'Medium',
    risk_high: 'High',

    // Tour
    tour_welcome: 'Welcome to IDFC',
    tour_welcome_desc: 'Discover the key features of the co-financing platform for the 27 IDFC member banks. This guided tour will only take a few moments.',
    tour_skip: 'Skip',
    tour_start: 'Start Tour',
    tour_back: 'Back',
    tour_next: 'Next',
    tour_last: 'Finish',
    tour_close: 'Close',
    tour_skip_all: 'Skip tour',

    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    projects: 'Projects',

    // Dashboard labels
    dash_total_projects: 'Total Projects',
    dash_pipeline_value: 'Pipeline Value',
    dash_funding_gap: 'Funding Gap',
    dash_active_deals: 'Active Deals',
    dash_filters: 'Filters',
    dash_sort: 'Sort',
    dash_score_filter: 'Score Filter',
    dash_all_sectors: 'All Sectors',
    dash_all_stages: 'All Stages',
    dash_all_countries: 'All Countries',
    dash_all_institutions: 'All Institutions',
    dash_default_order: 'Default Order',
    dash_funding_desc: 'Funding (desc)',
    dash_gap_asc: 'Gap (asc)',
    dash_return_desc: 'Return (desc)',
    dash_sector_distribution: 'Sector Distribution',
    dash_by_country: 'By Country',
    dash_recent_activity: 'Recent Activity',
    dash_investment_ready: 'Investment Ready Projects',
    dash_seed_data: 'Seed Demo Data',
    dash_required: 'Required',
    dash_gap: 'Gap',
    dash_return: 'Return',
    dash_add_favorite: 'Add to favorites',
    dash_remove_favorite: 'Remove from favorites',
    dash_favorites: 'My Favorites',
  },
  es: {
    "nav_dashboard": "Panel de Control",
    "nav_worklist": "Por Gestionar",
    "nav_briefing": "Mi resumen",
    "nav_pipeline": "Pipeline",
    "nav_institutions": "Instituciones",
    "nav_marketplace": "Marketplace",
    "nav_impact": "Impacto y ODS",
    "nav_knowledge": "Centro de Conocimiento",
    "nav_formation": "Centro de Capacitación",
    "nav_search": "Búsqueda",
    "nav_analytics": "Analítica",
    "nav_compare": "Comparar",
    "nav_submit": "Enviar",
    "nav_admin": "Administración",
    "nav_profile": "Mi Perfil",
    "nav_messages": "Mensajes",
    "logout": "Cerrar Sesión",
    "landing_badge": "27 Bancos de Desarrollo | ODS | Acuerdo de París",
    "landing_hero_1": "Club Internacional",
    "landing_hero_2": "de Financiamiento",
    "landing_hero_3": "al Desarrollo",
    "landing_desc": "La plataforma institucional de cofinanciamiento para los 27 bancos miembros de IDFC. Descubra, analice y cofinancie proyectos de desarrollo sostenible alineados con los ODS y el Acuerdo de París.",
    "landing_cta": "Acceder a la Plataforma",
    "landing_learn_more": "Más Información",
    "landing_cta_bottom": "¿Listo para Cofinanciar?",
    "landing_cta_bottom_desc": "Únase a la plataforma que conecta a las 27 instituciones miembros de IDFC con proyectos de desarrollo sostenible en todo el mundo.",
    "landing_start": "Comenzar",
    "landing_access": "Acceder",
    "stat_annual": "Compromisos Anuales",
    "stat_members": "Miembros IDFC",
    "stat_sdg": "ODS Cubiertos",
    "stat_continents": "Continentes",
    "section_sdg_title": "Alineados con los ODS y el Acuerdo de París",
    "section_sdg_desc": "IDFC moviliza colectivamente más de $900 mil millones anuales para contribuir a los Objetivos de Desarrollo Sostenible de las Naciones Unidas y los compromisos climáticos del Acuerdo de París.",
    "section_sdg_goals": "Objetivos de Desarrollo Sostenible",
    "section_paris": "Acuerdo de París",
    "section_how_title": "Cómo Funciona",
    "section_how_desc": "Desde el descubrimiento del proyecto hasta el cierre de la operación en cuatro pasos simplificados.",
    "section_sectors_title": "Sectores que Cubrimos",
    "section_sectors_desc": "Proyectos de infraestructura y desarrollo sostenible en los sectores de mayor impacto.",
    "section_platform_title": "Diseñada para la Toma de Decisiones Institucionales",
    "section_platform_desc": "Cada funcionalidad está diseñada para acelerar los flujos de trabajo de cofinanciamiento y apoyar los procesos de comités de inversión.",
    "section_members_title": "Los 27 Miembros de IDFC",
    "section_members_desc": "Una red única de bancos de desarrollo nacionales y regionales, presentes en 4 continentes, que movilizan colectivamente más de $900 mil millones por año.",
    "section_faq_title": "Preguntas Frecuentes",
    "section_footer": "International Development Finance Club | 27 Miembros | ODS y Acuerdo de París",
    "search_title": "Búsqueda Avanzada",
    "search_placeholder": "Buscar por título, país, sector, descripción...",
    "search_filters": "Filtros",
    "search_reset": "Restablecer",
    "search_country": "País",
    "search_sector": "Sector",
    "search_stage": "Etapa",
    "search_risk": "Nivel de Riesgo",
    "search_amount": "Monto",
    "search_sort": "Ordenar por",
    "search_all_countries": "Todos los países",
    "search_all_sectors": "Todos los sectores",
    "search_all_stages": "Todas las etapas",
    "search_all_risks": "Todos los niveles",
    "search_relevance": "Relevancia",
    "search_recent": "Más reciente",
    "search_funding_desc": "Monto (desc.)",
    "search_funding_asc": "Monto (asc.)",
    "search_readiness": "Nivel de Preparación",
    "search_results": "{count} resultado{s} encontrado{s}",
    "search_results_one": "resultado encontrado",
    "search_results_plural": "resultados encontrados",
    "search_no_results": "No se encontraron proyectos. Intente ajustar sus criterios de búsqueda.",
    "search_loading": "Buscando...",
    "analytics_title": "Analítica Avanzada",
    "analytics_pipeline": "Pipeline Total",
    "analytics_projects": "Proyectos Activos",
    "analytics_institutions": "Instituciones",
    "analytics_conversion": "Tasa de Conversión",
    "analytics_by_sector": "Pipeline por Sector",
    "analytics_by_country": "Pipeline por País",
    "analytics_by_stage": "Desglose por Etapa",
    "analytics_by_risk": "Distribución de Riesgo",
    "analytics_funding_gap": "Análisis de Brecha de Financiamiento",
    "analytics_funding": "Financiamiento",
    "analytics_gap": "Brecha",
    "analytics_required": "Requerido",
    "profile_title": "Mi Perfil",
    "profile_change_password": "Cambiar Contraseña",
    "profile_current_pw": "Contraseña actual",
    "profile_new_pw": "Nueva contraseña",
    "profile_confirm_pw": "Confirmar nueva contraseña",
    "profile_change_btn": "Cambiar contraseña",
    "profile_changing": "Cambiando...",
    "profile_activity": "Historial de Actividad",
    "profile_no_activity": "No se registró actividad reciente.",
    "profile_pw_mismatch": "Las contraseñas no coinciden",
    "profile_pw_short": "La contraseña debe tener al menos 8 caracteres",
    "profile_pw_success": "Contraseña cambiada exitosamente",
    "alerts_title": "Alertas Inteligentes",
    "alerts_desc": "Reciba notificaciones automáticas cuando un nuevo proyecto que coincida con sus criterios sea enviado a la plataforma.",
    "alerts_sectors": "Sectores de interés",
    "alerts_countries": "Países objetivo",
    "alerts_stages": "Etapas preferidas",
    "alerts_risks": "Niveles de riesgo",
    "alerts_min": "Monto mínimo ($)",
    "alerts_max": "Monto máximo ($)",
    "alerts_save": "Guardar preferencias",
    "alerts_saving": "Guardando...",
    "alerts_matches": "Proyectos Coincidentes",
    "alerts_matches_count": "{count} coincidencia{s}",
    "alerts_config_hint": "Configure sus preferencias arriba para ver proyectos coincidentes.",
    "alerts_no_match": "Actualmente no hay proyectos que coincidan con sus criterios.",
    "alerts_saved": "Preferencias de alerta guardadas",
    "alerts_active": "Activa",
    "alerts_inactive": "Inactiva",
    "messages_title": "Mensajería de Deal Room",
    "messages_placeholder": "Escriba su mensaje...",
    "messages_send": "Enviar",
    "messages_empty": "Aún no hay mensajes en este deal room. ¡Inicie la conversación!",
    "messages_visibility_all": "Visible para todos",
    "messages_visibility_inst": "Solo institución",
    "role_admin": "Administrador",
    "role_institution": "Institución",
    "role_donor": "Donante",
    "role_project_owner": "Propietario del Proyecto",
    "sector_energy": "Energía",
    "sector_infrastructure": "Infraestructura",
    "sector_agriculture": "Agricultura",
    "sector_climate": "Clima",
    "stage_early": "Temprana",
    "stage_structuring": "Estructuración",
    "stage_ready": "Lista para inversión",
    "risk_low": "Bajo",
    "risk_medium": "Medio",
    "risk_high": "Alto",
    "tour_welcome": "Bienvenido a IDFC",
    "tour_welcome_desc": "Descubra las funcionalidades clave de la plataforma de cofinanciamiento para los 27 bancos miembros de IDFC. Este recorrido guiado solo tomará unos momentos.",
    "tour_skip": "Omitir",
    "tour_start": "Iniciar Recorrido",
    "tour_back": "Atrás",
    "tour_next": "Siguiente",
    "tour_last": "Finalizar",
    "tour_close": "Cerrar",
    "tour_skip_all": "Omitir recorrido",
    "loading": "Cargando...",
    "error": "Error",
    "success": "Éxito",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "projects": "Proyectos",
    "dash_total_projects": "Total de Proyectos",
    "dash_pipeline_value": "Valor del Pipeline",
    "dash_funding_gap": "Brecha de Financiamiento",
    "dash_active_deals": "Operaciones Activas",
    "dash_filters": "Filtros",
    "dash_sort": "Ordenar",
    "dash_score_filter": "Filtro de Puntaje",
    "dash_all_sectors": "Todos los Sectores",
    "dash_all_stages": "Todas las Etapas",
    "dash_all_countries": "Todos los Países",
    "dash_all_institutions": "Todas las Instituciones",
    "dash_default_order": "Orden Predeterminado",
    "dash_funding_desc": "Financiamiento (desc)",
    "dash_gap_asc": "Brecha (asc)",
    "dash_return_desc": "Retorno (desc)",
    "dash_sector_distribution": "Distribución por Sector",
    "dash_by_country": "Por País",
    "dash_recent_activity": "Actividad Reciente",
    "dash_investment_ready": "Proyectos Listos para Inversión",
    "dash_seed_data": "Datos de Demostración",
    "dash_required": "Requerido",
    "dash_gap": "Brecha",
    "dash_return": "Retorno",
    "dash_add_favorite": "Agregar a favoritos",
    "dash_remove_favorite": "Quitar de favoritos",
    "dash_favorites": "Mis Favoritos",
  },
  pt: {
    "nav_dashboard": "Painel",
    "nav_worklist": "A processar",
    "nav_briefing": "Meu resumo",
    "nav_pipeline": "Pipeline",
    "nav_institutions": "Instituições",
    "nav_marketplace": "Marketplace",
    "nav_impact": "Impacto & ODS",
    "nav_knowledge": "Centro de Conhecimento",
    "nav_formation": "Centro de Capacitação",
    "nav_search": "Pesquisar",
    "nav_analytics": "Análises",
    "nav_compare": "Comparar",
    "nav_submit": "Submeter",
    "nav_admin": "Administração",
    "nav_profile": "Meu Perfil",
    "nav_messages": "Mensagens",
    "logout": "Sair",
    "landing_badge": "27 Bancos de Desenvolvimento | ODS | Acordo de Paris",
    "landing_hero_1": "Clube Internacional",
    "landing_hero_2": "de Financiamento",
    "landing_hero_3": "ao Desenvolvimento",
    "landing_desc": "A plataforma institucional de cofinanciamento para os 27 bancos membros do IDFC. Descubra, analise e cofinancie projetos de desenvolvimento sustentável alinhados com os ODS e o Acordo de Paris.",
    "landing_cta": "Acessar Plataforma",
    "landing_learn_more": "Saiba Mais",
    "landing_cta_bottom": "Pronto para Cofinanciar?",
    "landing_cta_bottom_desc": "Junte-se à plataforma que conecta as 27 instituições membros do IDFC com projetos de desenvolvimento sustentável em todo o mundo.",
    "landing_start": "Começar",
    "landing_access": "Acessar",
    "stat_annual": "Compromissos Anuais",
    "stat_members": "Membros IDFC",
    "stat_sdg": "ODS Cobertos",
    "stat_continents": "Continentes",
    "section_sdg_title": "Alinhado com os ODS & Acordo de Paris",
    "section_sdg_desc": "O IDFC mobiliza coletivamente mais de US$ 900 bilhões anualmente para contribuir com os Objetivos de Desenvolvimento Sustentável da ONU e os compromissos climáticos do Acordo de Paris.",
    "section_sdg_goals": "Objetivos de Desenvolvimento Sustentável",
    "section_paris": "Acordo de Paris",
    "section_how_title": "Como Funciona",
    "section_how_desc": "Da descoberta do projeto ao fechamento da operação em quatro etapas simplificadas.",
    "section_sectors_title": "Setores que Cobrimos",
    "section_sectors_desc": "Projetos de infraestrutura e desenvolvimento sustentável nos setores de maior impacto.",
    "section_platform_title": "Desenvolvido para Decisões Institucionais",
    "section_platform_desc": "Cada funcionalidade foi projetada para acelerar fluxos de cofinanciamento e apoiar processos de comitês de investimento.",
    "section_members_title": "Os 27 Membros do IDFC",
    "section_members_desc": "Uma rede única de bancos de desenvolvimento nacionais e regionais, presente em 4 continentes, mobilizando coletivamente mais de US$ 900 bilhões por ano.",
    "section_faq_title": "Perguntas Frequentes",
    "section_footer": "Clube Internacional de Financiamento ao Desenvolvimento | 27 Membros | ODS & Acordo de Paris",
    "search_title": "Pesquisa Avançada",
    "search_placeholder": "Pesquisar por título, país, setor, descrição...",
    "search_filters": "Filtros",
    "search_reset": "Limpar",
    "search_country": "País",
    "search_sector": "Setor",
    "search_stage": "Estágio",
    "search_risk": "Nível de Risco",
    "search_amount": "Valor",
    "search_sort": "Ordenar por",
    "search_all_countries": "Todos os países",
    "search_all_sectors": "Todos os setores",
    "search_all_stages": "Todos os estágios",
    "search_all_risks": "Todos os níveis",
    "search_relevance": "Relevância",
    "search_recent": "Mais recentes",
    "search_funding_desc": "Valor (decrescente)",
    "search_funding_asc": "Valor (crescente)",
    "search_readiness": "Prontidão",
    "search_results": "{count} resultado{s} encontrado{s}",
    "search_results_one": "resultado encontrado",
    "search_results_plural": "resultados encontrados",
    "search_no_results": "Nenhum projeto encontrado. Tente ajustar seus critérios de pesquisa.",
    "search_loading": "Pesquisando...",
    "analytics_title": "Análises Avançadas",
    "analytics_pipeline": "Pipeline Total",
    "analytics_projects": "Projetos Ativos",
    "analytics_institutions": "Instituições",
    "analytics_conversion": "Taxa de Conversão",
    "analytics_by_sector": "Pipeline por Setor",
    "analytics_by_country": "Pipeline por País",
    "analytics_by_stage": "Distribuição por Estágio",
    "analytics_by_risk": "Distribuição de Risco",
    "analytics_funding_gap": "Análise de Lacuna de Financiamento",
    "analytics_funding": "Financiamento",
    "analytics_gap": "Lacuna",
    "analytics_required": "Necessário",
    "profile_title": "Meu Perfil",
    "profile_change_password": "Alterar Senha",
    "profile_current_pw": "Senha atual",
    "profile_new_pw": "Nova senha",
    "profile_confirm_pw": "Confirmar nova senha",
    "profile_change_btn": "Alterar senha",
    "profile_changing": "Alterando...",
    "profile_activity": "Histórico de Atividades",
    "profile_no_activity": "Nenhuma atividade recente registrada.",
    "profile_pw_mismatch": "As senhas não coincidem",
    "profile_pw_short": "A senha deve ter no mínimo 8 caracteres",
    "profile_pw_success": "Senha alterada com sucesso",
    "alerts_title": "Alertas Inteligentes",
    "alerts_desc": "Receba notificações automáticas quando um novo projeto correspondente aos seus critérios for submetido na plataforma.",
    "alerts_sectors": "Setores de interesse",
    "alerts_countries": "Países-alvo",
    "alerts_stages": "Estágios preferidos",
    "alerts_risks": "Níveis de risco",
    "alerts_min": "Valor mínimo ($)",
    "alerts_max": "Valor máximo ($)",
    "alerts_save": "Salvar preferências",
    "alerts_saving": "Salvando...",
    "alerts_matches": "Projetos Correspondentes",
    "alerts_matches_count": "{count} correspondência{s}",
    "alerts_config_hint": "Configure suas preferências acima para ver projetos correspondentes.",
    "alerts_no_match": "Nenhum projeto corresponde aos seus critérios no momento.",
    "alerts_saved": "Preferências de alerta salvas",
    "alerts_active": "Ativo",
    "alerts_inactive": "Inativo",
    "messages_title": "Mensagens da Sala de Negociação",
    "messages_placeholder": "Digite sua mensagem...",
    "messages_send": "Enviar",
    "messages_empty": "Ainda não há mensagens nesta sala de negociação. Inicie a conversa!",
    "messages_visibility_all": "Visível para todos",
    "messages_visibility_inst": "Somente instituição",
    "role_admin": "Administrador",
    "role_institution": "Instituição",
    "role_donor": "Doador",
    "role_project_owner": "Proprietário do Projeto",
    "sector_energy": "Energia",
    "sector_infrastructure": "Infraestrutura",
    "sector_agriculture": "Agricultura",
    "sector_climate": "Clima",
    "stage_early": "Inicial",
    "stage_structuring": "Estruturação",
    "stage_ready": "Pronto para investimento",
    "risk_low": "Baixo",
    "risk_medium": "Médio",
    "risk_high": "Alto",
    "tour_welcome": "Bem-vindo ao IDFC",
    "tour_welcome_desc": "Descubra os principais recursos da plataforma de cofinanciamento para os 27 bancos membros do IDFC. Este tour guiado levará apenas alguns instantes.",
    "tour_skip": "Pular",
    "tour_start": "Iniciar Tour",
    "tour_back": "Voltar",
    "tour_next": "Próximo",
    "tour_last": "Concluir",
    "tour_close": "Fechar",
    "tour_skip_all": "Pular tour",
    "loading": "Carregando...",
    "error": "Erro",
    "success": "Sucesso",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "edit": "Editar",
    "close": "Fechar",
    "projects": "Projetos",
    "dash_total_projects": "Total de Projetos",
    "dash_pipeline_value": "Valor do Pipeline",
    "dash_funding_gap": "Lacuna de Financiamento",
    "dash_active_deals": "Operações Ativas",
    "dash_filters": "Filtros",
    "dash_sort": "Ordenar",
    "dash_score_filter": "Filtro de Pontuação",
    "dash_all_sectors": "Todos os Setores",
    "dash_all_stages": "Todos os Estágios",
    "dash_all_countries": "Todos os Países",
    "dash_all_institutions": "Todas as Instituições",
    "dash_default_order": "Ordem Padrão",
    "dash_funding_desc": "Financiamento (decrescente)",
    "dash_gap_asc": "Lacuna (crescente)",
    "dash_return_desc": "Retorno (decrescente)",
    "dash_sector_distribution": "Distribuição por Setor",
    "dash_by_country": "Por País",
    "dash_recent_activity": "Atividade Recente",
    "dash_investment_ready": "Projetos Prontos para Investimento",
    "dash_seed_data": "Dados de Demonstração",
    "dash_required": "Necessário",
    "dash_gap": "Lacuna",
    "dash_return": "Retorno",
    "dash_add_favorite": "Adicionar aos favoritos",
    "dash_remove_favorite": "Remover dos favoritos",
    "dash_favorites": "Meus Favoritos",
  },
  ja: {
    "nav_dashboard": "ダッシュボード",
    "nav_worklist": "処理待ち",
    "nav_briefing": "今日の要約",
    "nav_pipeline": "パイプライン",
    "nav_institutions": "機関",
    "nav_marketplace": "マーケットプレイス",
    "nav_impact": "インパクト & SDG",
    "nav_knowledge": "ナレッジハブ",
    "nav_formation": "研修センター",
    "nav_search": "検索",
    "nav_analytics": "分析",
    "nav_compare": "比較",
    "nav_submit": "提出",
    "nav_admin": "管理",
    "nav_profile": "マイプロフィール",
    "nav_messages": "メッセージ",
    "logout": "ログアウト",
    "landing_badge": "27の開発銀行 | SDGs | Paris Agreement",
    "landing_hero_1": "国際",
    "landing_hero_2": "開発金融",
    "landing_hero_3": "クラブ",
    "landing_desc": "IDFC加盟27銀行のための機関間協調融資プラットフォーム。SDGsおよびParis Agreementに沿った持続可能な開発プロジェクトを発見、分析、協調融資いたします。",
    "landing_cta": "プラットフォームにアクセス",
    "landing_learn_more": "詳細を見る",
    "landing_cta_bottom": "協調融資の準備はよろしいですか?",
    "landing_cta_bottom_desc": "IDFC加盟27機関と世界中の持続可能な開発プロジェクトをつなぐプラットフォームにご参加ください。",
    "landing_start": "開始する",
    "landing_access": "アクセス",
    "stat_annual": "年間コミットメント",
    "stat_members": "IDFC加盟機関",
    "stat_sdg": "対象SDGs",
    "stat_continents": "大陸",
    "section_sdg_title": "SDGs & Paris Agreementに準拠",
    "section_sdg_desc": "IDFCは年間9,000億ドル以上を集団で動員し、国連の持続可能な開発目標とParis Agreementの気候コミットメントに貢献しております。",
    "section_sdg_goals": "持続可能な開発目標",
    "section_paris": "Paris Agreement",
    "section_how_title": "仕組み",
    "section_how_desc": "プロジェクト発見から案件成立まで、4つの合理化されたステップで実現します。",
    "section_sectors_title": "対象セクター",
    "section_sectors_desc": "最も影響力の高いセクターにおけるインフラおよび持続可能な開発プロジェクト。",
    "section_platform_title": "機関の意思決定のために構築",
    "section_platform_desc": "すべての機能は、協調融資ワークフローを加速し、投資委員会プロセスを支援するように設計されております。",
    "section_members_title": "IDFC加盟27機関",
    "section_members_desc": "4大陸に存在する国内および地域開発銀行の独自のネットワークで、年間9,000億ドル以上を集団で動員しております。",
    "section_faq_title": "よくあるご質問",
    "section_footer": "International Development Finance Club | 27加盟機関 | SDGs & Paris Agreement",
    "search_title": "詳細検索",
    "search_placeholder": "タイトル、国、セクター、説明で検索...",
    "search_filters": "フィルター",
    "search_reset": "リセット",
    "search_country": "国",
    "search_sector": "セクター",
    "search_stage": "ステージ",
    "search_risk": "リスクレベル",
    "search_amount": "金額",
    "search_sort": "並び替え",
    "search_all_countries": "すべての国",
    "search_all_sectors": "すべてのセクター",
    "search_all_stages": "すべてのステージ",
    "search_all_risks": "すべてのレベル",
    "search_relevance": "関連性",
    "search_recent": "最新順",
    "search_funding_desc": "金額（降順）",
    "search_funding_asc": "金額（昇順）",
    "search_readiness": "準備状況",
    "search_results": "{count}件の結果が見つかりました",
    "search_results_one": "件の結果が見つかりました",
    "search_results_plural": "件の結果が見つかりました",
    "search_no_results": "プロジェクトが見つかりませんでした。検索条件を調整してください。",
    "search_loading": "検索中...",
    "analytics_title": "高度な分析",
    "analytics_pipeline": "パイプライン総計",
    "analytics_projects": "進行中プロジェクト",
    "analytics_institutions": "機関",
    "analytics_conversion": "成約率",
    "analytics_by_sector": "セクター別パイプライン",
    "analytics_by_country": "国別パイプライン",
    "analytics_by_stage": "ステージ別内訳",
    "analytics_by_risk": "リスク分布",
    "analytics_funding_gap": "資金ギャップ分析",
    "analytics_funding": "資金調達",
    "analytics_gap": "ギャップ",
    "analytics_required": "必要額",
    "profile_title": "マイプロフィール",
    "profile_change_password": "パスワード変更",
    "profile_current_pw": "現在のパスワード",
    "profile_new_pw": "新しいパスワード",
    "profile_confirm_pw": "新しいパスワード（確認）",
    "profile_change_btn": "パスワードを変更",
    "profile_changing": "変更中...",
    "profile_activity": "活動履歴",
    "profile_no_activity": "最近の活動は記録されておりません。",
    "profile_pw_mismatch": "パスワードが一致しません",
    "profile_pw_short": "パスワードは8文字以上である必要があります",
    "profile_pw_success": "パスワードが正常に変更されました",
    "alerts_title": "スマートアラート",
    "alerts_desc": "お客様の条件に一致する新しいプロジェクトがプラットフォームに提出された際に、自動通知を受け取ります。",
    "alerts_sectors": "関心のあるセクター",
    "alerts_countries": "対象国",
    "alerts_stages": "希望ステージ",
    "alerts_risks": "リスクレベル",
    "alerts_min": "最小金額（$）",
    "alerts_max": "最大金額（$）",
    "alerts_save": "設定を保存",
    "alerts_saving": "保存中...",
    "alerts_matches": "一致するプロジェクト",
    "alerts_matches_count": "{count}件の一致",
    "alerts_config_hint": "一致するプロジェクトを表示するには、上記で設定を行ってください。",
    "alerts_no_match": "現在、お客様の条件に一致するプロジェクトはございません。",
    "alerts_saved": "アラート設定が保存されました",
    "alerts_active": "有効",
    "alerts_inactive": "無効",
    "messages_title": "ディールルーム メッセージング",
    "messages_placeholder": "メッセージを入力...",
    "messages_send": "送信",
    "messages_empty": "このディールルームにはまだメッセージがありません。会話を始めてください！",
    "messages_visibility_all": "全員に表示",
    "messages_visibility_inst": "機関のみ",
    "role_admin": "管理者",
    "role_institution": "機関",
    "role_donor": "ドナー",
    "role_project_owner": "プロジェクトオーナー",
    "sector_energy": "エネルギー",
    "sector_infrastructure": "インフラ",
    "sector_agriculture": "農業",
    "sector_climate": "気候",
    "stage_early": "初期段階",
    "stage_structuring": "組成中",
    "stage_ready": "投資可能",
    "risk_low": "低",
    "risk_medium": "中",
    "risk_high": "高",
    "tour_welcome": "IDFCへようこそ",
    "tour_welcome_desc": "IDFC加盟27銀行のための協調融資プラットフォームの主要機能をご覧ください。このガイドツアーは数分で完了いたします。",
    "tour_skip": "スキップ",
    "tour_start": "ツアーを開始",
    "tour_back": "戻る",
    "tour_next": "次へ",
    "tour_last": "完了",
    "tour_close": "閉じる",
    "tour_skip_all": "ツアーをスキップ",
    "loading": "読み込み中...",
    "error": "エラー",
    "success": "成功",
    "save": "保存",
    "cancel": "キャンセル",
    "delete": "削除",
    "edit": "編集",
    "close": "閉じる",
    "projects": "プロジェクト",
    "dash_total_projects": "総プロジェクト数",
    "dash_pipeline_value": "パイプライン価値",
    "dash_funding_gap": "資金ギャップ",
    "dash_active_deals": "進行中案件",
    "dash_filters": "フィルター",
    "dash_sort": "並び替え",
    "dash_score_filter": "スコアフィルター",
    "dash_all_sectors": "全セクター",
    "dash_all_stages": "全ステージ",
    "dash_all_countries": "全ての国",
    "dash_all_institutions": "全機関",
    "dash_default_order": "デフォルト順",
    "dash_funding_desc": "資金調達（降順）",
    "dash_gap_asc": "ギャップ（昇順）",
    "dash_return_desc": "リターン（降順）",
    "dash_sector_distribution": "セクター分布",
    "dash_by_country": "国別",
    "dash_recent_activity": "最近の活動",
    "dash_investment_ready": "投資可能プロジェクト",
    "dash_seed_data": "デモデータ作成",
    "dash_required": "必要額",
    "dash_gap": "ギャップ",
    "dash_return": "リターン",
    "dash_add_favorite": "お気に入りに追加",
    "dash_remove_favorite": "お気に入りから削除",
    "dash_favorites": "マイお気に入り",
  },
  it: {
    "nav_dashboard": "Dashboard",
    "nav_worklist": "Da gestire",
    "nav_briefing": "Il mio briefing",
    "nav_pipeline": "Pipeline",
    "nav_institutions": "Istituzioni",
    "nav_marketplace": "Marketplace",
    "nav_impact": "Impatto & SDG",
    "nav_knowledge": "Hub della Conoscenza",
    "nav_formation": "Centro Formazione",
    "nav_search": "Ricerca",
    "nav_analytics": "Analisi",
    "nav_compare": "Confronta",
    "nav_submit": "Invia",
    "nav_admin": "Amministrazione",
    "nav_profile": "Il Mio Profilo",
    "nav_messages": "Messaggi",
    "logout": "Esci",
    "landing_badge": "27 Banche di Sviluppo | SDG | Paris Agreement",
    "landing_hero_1": "International",
    "landing_hero_2": "Development Finance",
    "landing_hero_3": "Club",
    "landing_desc": "La piattaforma istituzionale di cofinanziamento per le 27 banche membri IDFC. Scopri, analizza e cofinanzia progetti di sviluppo sostenibile allineati agli SDG e al Paris Agreement.",
    "landing_cta": "Accedi alla Piattaforma",
    "landing_learn_more": "Maggiori Informazioni",
    "landing_cta_bottom": "Pronti a Cofinanziare?",
    "landing_cta_bottom_desc": "Entra nella piattaforma che connette le 27 istituzioni membri IDFC con progetti di sviluppo sostenibile in tutto il mondo.",
    "landing_start": "Inizia",
    "landing_access": "Accedi",
    "stat_annual": "Impegni Annuali",
    "stat_members": "Membri IDFC",
    "stat_sdg": "SDG Coperti",
    "stat_continents": "Continenti",
    "section_sdg_title": "Allineati agli SDG & Paris Agreement",
    "section_sdg_desc": "IDFC mobilita collettivamente oltre 900 miliardi di dollari all'anno per contribuire agli Obiettivi di Sviluppo Sostenibile delle Nazioni Unite e agli impegni climatici del Paris Agreement.",
    "section_sdg_goals": "Obiettivi di Sviluppo Sostenibile",
    "section_paris": "Paris Agreement",
    "section_how_title": "Come Funziona",
    "section_how_desc": "Dalla scoperta del progetto alla chiusura dell'operazione in quattro fasi semplificate.",
    "section_sectors_title": "Settori Coperti",
    "section_sectors_desc": "Progetti infrastrutturali e di sviluppo sostenibile nei settori ad alto impatto.",
    "section_platform_title": "Progettata per il Processo Decisionale Istituzionale",
    "section_platform_desc": "Ogni funzionalità è progettata per accelerare i flussi di lavoro di cofinanziamento e supportare i processi dei comitati di investimento.",
    "section_members_title": "I 27 Membri IDFC",
    "section_members_desc": "Una rete unica di banche nazionali e regionali di sviluppo, presente in 4 continenti, che mobilita collettivamente oltre 900 miliardi di dollari all'anno.",
    "section_faq_title": "Domande Frequenti",
    "section_footer": "International Development Finance Club | 27 Membri | SDG & Paris Agreement",
    "search_title": "Ricerca Avanzata",
    "search_placeholder": "Cerca per titolo, paese, settore, descrizione...",
    "search_filters": "Filtri",
    "search_reset": "Ripristina",
    "search_country": "Paese",
    "search_sector": "Settore",
    "search_stage": "Fase",
    "search_risk": "Livello di Rischio",
    "search_amount": "Importo",
    "search_sort": "Ordina per",
    "search_all_countries": "Tutti i paesi",
    "search_all_sectors": "Tutti i settori",
    "search_all_stages": "Tutte le fasi",
    "search_all_risks": "Tutti i livelli",
    "search_relevance": "Rilevanza",
    "search_recent": "Più recenti",
    "search_funding_desc": "Importo (decr.)",
    "search_funding_asc": "Importo (cresc.)",
    "search_readiness": "Maturità",
    "search_results": "{count} risultat{s} trovat{s}",
    "search_results_one": "risultato trovato",
    "search_results_plural": "risultati trovati",
    "search_no_results": "Nessun progetto trovato. Prova a modificare i criteri di ricerca.",
    "search_loading": "Ricerca in corso...",
    "analytics_title": "Analisi Avanzate",
    "analytics_pipeline": "Pipeline Totale",
    "analytics_projects": "Progetti Attivi",
    "analytics_institutions": "Istituzioni",
    "analytics_conversion": "Tasso di Conversione",
    "analytics_by_sector": "Pipeline per Settore",
    "analytics_by_country": "Pipeline per Paese",
    "analytics_by_stage": "Ripartizione per Fase",
    "analytics_by_risk": "Distribuzione del Rischio",
    "analytics_funding_gap": "Analisi del Fabbisogno di Finanziamento",
    "analytics_funding": "Finanziamento",
    "analytics_gap": "Fabbisogno",
    "analytics_required": "Richiesto",
    "profile_title": "Il Mio Profilo",
    "profile_change_password": "Modifica Password",
    "profile_current_pw": "Password attuale",
    "profile_new_pw": "Nuova password",
    "profile_confirm_pw": "Conferma nuova password",
    "profile_change_btn": "Modifica password",
    "profile_changing": "Modifica in corso...",
    "profile_activity": "Storico Attività",
    "profile_no_activity": "Nessuna attività recente registrata.",
    "profile_pw_mismatch": "Le password non corrispondono",
    "profile_pw_short": "La password deve contenere almeno 8 caratteri",
    "profile_pw_success": "Password modificata con successo",
    "alerts_title": "Avvisi Intelligenti",
    "alerts_desc": "Ricevi notifiche automatiche quando un nuovo progetto corrispondente ai tuoi criteri viene inserito sulla piattaforma.",
    "alerts_sectors": "Settori di interesse",
    "alerts_countries": "Paesi target",
    "alerts_stages": "Fasi preferite",
    "alerts_risks": "Livelli di rischio",
    "alerts_min": "Importo min ($)",
    "alerts_max": "Importo max ($)",
    "alerts_save": "Salva preferenze",
    "alerts_saving": "Salvataggio...",
    "alerts_matches": "Progetti Corrispondenti",
    "alerts_matches_count": "{count} corrispondenz{s}",
    "alerts_config_hint": "Configura le tue preferenze sopra per visualizzare i progetti corrispondenti.",
    "alerts_no_match": "Nessun progetto corrisponde attualmente ai tuoi criteri.",
    "alerts_saved": "Preferenze avvisi salvate",
    "alerts_active": "Attivo",
    "alerts_inactive": "Inattivo",
    "messages_title": "Messaggistica Deal Room",
    "messages_placeholder": "Scrivi il tuo messaggio...",
    "messages_send": "Invia",
    "messages_empty": "Nessun messaggio in questa deal room. Avvia la conversazione!",
    "messages_visibility_all": "Visibile a tutti",
    "messages_visibility_inst": "Solo istituzione",
    "role_admin": "Amministratore",
    "role_institution": "Istituzione",
    "role_donor": "Donatore",
    "role_project_owner": "Proponente del Progetto",
    "sector_energy": "Energia",
    "sector_infrastructure": "Infrastrutture",
    "sector_agriculture": "Agricoltura",
    "sector_climate": "Clima",
    "stage_early": "Iniziale",
    "stage_structuring": "Strutturazione",
    "stage_ready": "Pronto per l'investimento",
    "risk_low": "Basso",
    "risk_medium": "Medio",
    "risk_high": "Alto",
    "tour_welcome": "Benvenuto in IDFC",
    "tour_welcome_desc": "Scopri le funzionalità principali della piattaforma di cofinanziamento per le 27 banche membri IDFC. Questo tour guidato richiederà solo pochi istanti.",
    "tour_skip": "Salta",
    "tour_start": "Avvia Tour",
    "tour_back": "Indietro",
    "tour_next": "Avanti",
    "tour_last": "Termina",
    "tour_close": "Chiudi",
    "tour_skip_all": "Salta tour",
    "loading": "Caricamento...",
    "error": "Errore",
    "success": "Successo",
    "save": "Salva",
    "cancel": "Annulla",
    "delete": "Elimina",
    "edit": "Modifica",
    "close": "Chiudi",
    "projects": "Progetti",
    "dash_total_projects": "Progetti Totali",
    "dash_pipeline_value": "Valore Pipeline",
    "dash_funding_gap": "Fabbisogno di Finanziamento",
    "dash_active_deals": "Operazioni Attive",
    "dash_filters": "Filtri",
    "dash_sort": "Ordina",
    "dash_score_filter": "Filtro Punteggio",
    "dash_all_sectors": "Tutti i Settori",
    "dash_all_stages": "Tutte le Fasi",
    "dash_all_countries": "Tutti i Paesi",
    "dash_all_institutions": "Tutte le Istituzioni",
    "dash_default_order": "Ordine Predefinito",
    "dash_funding_desc": "Finanziamento (decr)",
    "dash_gap_asc": "Fabbisogno (cresc)",
    "dash_return_desc": "Rendimento (decr)",
    "dash_sector_distribution": "Distribuzione per Settore",
    "dash_by_country": "Per Paese",
    "dash_recent_activity": "Attività Recente",
    "dash_investment_ready": "Progetti Pronti per l'Investimento",
    "dash_seed_data": "Dati Demo",
    "dash_required": "Richiesto",
    "dash_gap": "Fabbisogno",
    "dash_return": "Rendimento",
    "dash_add_favorite": "Aggiungi ai preferiti",
    "dash_remove_favorite": "Rimuovi dai preferiti",
    "dash_favorites": "I Miei Preferiti",
  }
};

export default translations;
